import {Head, router, useForm} from '@inertiajs/react'
import Layout from "../../components/layout";
import {ArrowRightIcon} from '@heroicons/react/24/solid/index.js';
import {useCallback, useEffect} from 'react';
import colors from '../../colors.js';
import toast from 'react-hot-toast';

export default function Login({eventId, email, emailLoginUrl, checkEmailUrl}) {

    const {data, setData, post, processing, errors} = useForm({
        email: email,
        name: '',
    })

    const logInAsGuest = useCallback(() => {
        post(emailLoginUrl);
    }, [data.email, data.name]);

    useEffect(() => {
        if (!!errors.email){
            toast.error('Please check your email.')
            router.get(checkEmailUrl)
        }
    }, [errors.email, checkEmailUrl]);

    return (<Layout>
        <Head title={"Log in"}/>
        <div className="relative h-full">
            <div
                className="flex full-screen h-full flex-col grow bg-linear-to-b from-transparent via-transparent to-black px-[20px] pb-[20px]">
                <div className="flex grow flex-col items-center justify-center">
                    <div className="w-full">

                        <div>
                            <label className="text-white-foreground font-bold" htmlFor="email">What's your name?</label>
                            <input
                                required
                                id="email"
                                placeholder={'Mike Ross'}
                                className="w-full border-2 py-4 px-6 rounded-[20px] text-white-foreground"
                                style={{
                                    backgroundColor: colors.backdropBackground,
                                    borderColor: colors.borderBottomColor,
                                }}
                                type="name"
                                value={data.name}
                                onChange={e => setData('name', e.target.value)}
                            />
                            <div>
                                {errors.name && <small className="text-red-500">{errors.name}</small>}
                            </div>
                            <small className="text-white-foreground">So we can send you an email when the album
                                reveals.</small>
                        </div>
                        <button
                            className="flex-wrap w-full shadow-sm transition duration-300 transform px-6 py-3 font-medium text-white-foreground mt-[10px] primary-camera-button/80 focus:bg-primary-500/80 text-center flex flex-row items-center justify-center"
                            type="button"
                            disabled={processing}
                            onClick={logInAsGuest}>
                            Continue <ArrowRightIcon className="w-4 h-4 text-white-foreground ml-2"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Layout>)
}
